import React, { Component } from 'react';
import moment from 'moment';

import Loading from '../../components/Loading';

import { connect } from 'react-redux';
import * as actions from '../../actions/pedidos';
import { formatMoney } from '../../actions';

import Titulo from '../../components/Texto/Titulo';
import Pesquisa from '../../components/Inputs/Pesquisa';
import Filters from '../../components/Filters/Orders';
import OrdersTable from '../../components/Table/orders';
import Paginacao from '../../components/Paginacao/Simples';

import Modal from '../../components/Modal/Simple';
import { Link } from 'react-router-dom';
import { ORDERS_CHANGED_EVENT } from '../../services/orderEvents';

class Pedidos extends Component {

	state = { pesquisa: "", atual: 0, limit: 20, refreshing: false, pendingView: false, searchError: null }

	getPedidos(){
		const { atual, limit, pesquisa } = this.state;
		const { usuario } = this.props;
		
		if(!usuario) return null;
		if(pesquisa) this.props.getPedidosPesquisa(pesquisa, atual, limit, usuario.loja, JSON.parse(window.localStorage.getItem('orderFilters')));
		else this.props.getPedidos(atual, limit, usuario.loja, JSON.parse(window.localStorage.getItem('orderFilters')));
	}

	onOrdersChanged = (event) => {
		const { action, simpleId } = event.detail || {};
		if (action === 'created') {
			this.createNotification(simpleId);
			this.startTitleBlink(simpleId);
		}
		this.getPedidos();
	}
	
	componentDidMount(){
		this.getPedidos();
		if(localStorage.getItem("pendingView")){
			this.setState({ pendingView: true });
		}
		
		this.blinkInterval = null;
		
		window.addEventListener("mousedown", this.handleMouseDown);
		window.addEventListener(ORDERS_CHANGED_EVENT, this.onOrdersChanged);

		this.enableNotifications();
	}
	
	componentWillUnmount() {
		window.removeEventListener("mousedown", this.handleMouseDown);
		window.removeEventListener(ORDERS_CHANGED_EVENT, this.onOrdersChanged);
		this.clearBlinkInterval();
	}
	
	handleMouseDown = () => {
		this.clearBlinkInterval();
		document.title = 'Dashboard'; // Restaurar título original
	}
	
	clearBlinkInterval = () => {
		if (this.blinkInterval) {
			clearInterval(this.blinkInterval);
			this.blinkInterval = null;
		}
	}

	startTitleBlink = (simpleId) => {
		// Limpar intervalo anterior se existir
		this.clearBlinkInterval();
		
		// Função para alternar o título
		const toggleTitle = () => {
			document.title = (document.title === 'Novo Pedido!') ? ' ' : 'Novo Pedido!';
		};
		
		// Iniciar o intervalo de alternância
		this.blinkInterval = setInterval(toggleTitle, 500);

		// Parar de piscar após 5 minutos
		setTimeout(() => {
			this.clearBlinkInterval();
			document.title = 'Dashboard'; // Restaurar título original
		}, 300000); // 5 minutos = 300000ms
	}

	enableNotifications(){
		if (typeof Notification !== "undefined") { // Verifica se Notification está disponível
			if (Notification.permission === "granted") {
				// Permissões já concedidas
			} else if (Notification.permission !== "denied") {
				Notification.requestPermission().then(permission => {
					// Tratamos a resposta da solicitação de permissão
				});
			}
		}
	}

	createNotification(simpleId = "") {
		if (typeof Notification !== "undefined" && Notification.permission === "granted") {
			const notification = new Notification("Novo pedido recebido!", {
				body: simpleId ? `Pedido #${simpleId} recebido!` : "Novo pedido recebido!",
				icon: "https://admin.juliafloresrj.com.br/favicons/favicon.ico",
			});

			notification.onclick = () => {
				window.focus();
				this.handleMouseDown(); // Parar o efeito de piscar ao clicar na notificação
			};
		} else {
			console.warn("Notificações não suportadas ou permissão não concedida.");
		}
	}

	handleSubmitPesquisa(){
		const { atual, limit, pesquisa } = this.state;
		const { usuario } = this.props;
		const termo = pesquisa?.split(' ').join('').toLowerCase().replace(/[^\w\s]/gi, '') || '';

		if (termo.length > 0 && termo.length < 3) {
			this.setState({ searchError: 'Digite ao menos 3 caracteres para pesquisar.' });
			return;
		}

		if (termo.length > 0) {
			this.setState({ refreshing: true, searchError: null });
			this.setState({ atual: 0 }, () => {
				if (!usuario) return null;
				this.props.getPedidosPesquisa(termo, atual, limit, usuario.loja, JSON.parse(window.localStorage.getItem('orderFilters')), () => this.setState({ refreshing: false }));
			});
		}
	}

	onChangePesquisa = (ev) => this.setState({ pesquisa: ev.target.value });

	changeNumberCurrent = (newNumber) => {
		this.setState({ atual: newNumber }, () => {
			this.getPedidos();
		});
	}

	refreshList = () => {
		this.setState({ refreshing: true })
		this.props.limparPedidos();
		this.getPedidos();
		
		const timer = setTimeout(() => {
			this.setState({ refreshing: false })
			clearTimeout(timer)
		}, 3000);
	}

	cancelSeen = () => {
		localStorage.removeItem("pendingView")
		this.setState({ pendingView: false })
	}

	confirmSeen = async () => {
		const idSeen = localStorage.getItem("pendingView");
		await this.props.seenOrder(idSeen, this.props.usuario.loja, 2)
		localStorage.removeItem("pendingView")
		this.setState({ pendingView: false });
		this.refreshList();
	}

	render(){
		const { pesquisa, refreshing, pendingView, searchError } = this.state;
		const { pedidos } = this.props;

		const dados = [];
		(pedidos ? pedidos.docs : []).forEach((item, index) => {
			if(!item || !item.pagamento) return;
			
			// Gerar ID único para evitar conflitos com simpleId duplicados
			const uniqueId = `${item.pagamento.pedido._id}_${index}`;
			
			dados.push({
				"Ações": `/pedido/${item.pagamento.pedido._id}`,
				"Cliente": item.pagamento.pedido.cliente ? item.pagamento.pedido.cliente.nome : "",
				"Data Compra": moment(item.pagamento.pedido.createdAt).format("DD/MM/YYYY"),
				"Data Entrega": item.pagamento.pedido.entrega ? item.pagamento.pedido.entrega.shippingDate : "Não encontrado",
				"Valor": formatMoney(item.pagamento.valor || 0),
				"valueCart": formatMoney(item.pagamento.valueCart ? item.pagamento.valueCart : 0),
				"Situação": item.pagamento.pedido.cancelado ? "Cancelado" : item ? item.pagamento.status : "Não encontrado",
				"Seen": item.pagamento.pedido.seen,
				"manual": item.pagamento.pedido.manualOrder ? item.pagamento.pedido.manualOrder : false,
				"paymentMethod": item.pagamento.forma || "Não encontrado",
				"ID": item.pagamento.pedido.simpleId ? item.pagamento.pedido.simpleId : item.pagamento.pedido._id,
				"uniqueId": uniqueId, // ID único para React key
				pedido: item.pagamento.pedido,
				registros: {
					pagamento: (item.registros || []).reduce((all, item) => (item.tipo === "pagamento") ? all.concat([item]) : all, []),
					entrega: (item.registros || []).reduce((all, item) => (item.tipo === "entrega") ? all.concat([item]) : all, []),
					card: item.pagamento.payload
				},
				pagamento: {
					parcelas: item.pagamento.parcelas,
					status: item.pagamento.status,
					card: item.pagamento.payload
				},
				cliente: {
					whatsapp: item.pagamento.pedido.cliente.telefones[0]
				}
			});
		});

		return (
			<>

				{ pendingView && (
					<Modal h1="Deseja marcar este pedido como visualizado?" cancelFunction={() => this.cancelSeen()} confirmFunction={() => this.confirmSeen()} />
				) }

				{ pedidos ? (
					<div className="SectionOrders">
						<div className="Page-Title">
							<Titulo tipo="h1" titulo="Pedidos"/>
						</div>

						<div className="actionsTollBar">
							<Filters refreshList={() => this.refreshList()} currentAction={() => this.setState({ atual: 0 })} />
							<Link to="/neworder">
								<div className="btnIcon plus"></div>
							</Link>
							<Pesquisa valor={pesquisa}
								placeholder={"Pesquise pelo Nome, Telefone, CPF, E-mail ou ID (mín. 3 caracteres)"}
								onChange={(ev) => this.onChangePesquisa(ev)}
								onClick={() => this.handleSubmitPesquisa()}/>
							{searchError && <p className="search-error-hint">{searchError}</p>}
						</div>

						<OrdersTable admin={this.props.usuario} cabecalho={["ID", "Cliente", "Data Compra", "Data Entrega", "Valor", "Seen" ]} gridClass="Orders" refreshState={refreshing} dados={dados} refreshList={() => this.refreshList()} />

						<Paginacao atual={this.state.atual}
							total={this.props.pedidos?.total || 1} 
							limite={this.state.limit} 
							onClick={(newNumber) => this.changeNumberCurrent(newNumber)}/>
					</div>
				) : <Loading /> }
			</>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	pedidos: state.pedido.pedidos,
	usuario: state.auth.usuario
});

export default connect(mapStateToProps, actions)(Pedidos);